import React, { Component } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { strings } from '../resources/strings';
import { ContactCommand } from './commands/ContactCommand';

export class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            commands: {
                contacts: new ContactCommand()
            },
            sending: false,
            result: undefined
        };
    }

    sendMail = (e) => {
        e.preventDefault();

        this.setState({ sending: true });
        this.state.commands.contacts.sendEmail({
            name: e.target.name.value,
            email: e.target.email.value,
            subject: `${e.target.subjectType.value} - ${e.target.subject.value}`,
            message: e.target.message.value
        }, (r) => this.sendSuccessCallback(r), (r) => this.sendErrorCallback(r));
    }

    sendSuccessCallback(result) {
        this.setState({
            sending: false,
            result: true
        });
    }

    sendErrorCallback(result) {
        this.setState({
            sending: false,
            result: false
        });
    }

    onCheckboxChange() {
        const { sending } = this.state;
        this.setState({
            sending: !sending,
        });
    }

    render() {
        const subjectOptions = [strings.general, strings.landingPageTickets, strings.landingPageServiceOnDemand, strings.contactComplaints];

        return (
            <Container fluid className="mb-5" >
                <Row>
                    <Col lg={4}>
                        <div class="mt-5">
                            <b>{strings.contactHeader}</b><br />
                            <b>Terminal Rodoviário de Évora<br />
                                Av.Tulio Espanca - Terminal Rodoviário<br/>
                                7005 - 840 Évora</b><br />
                            <b>{strings.email}:</b> geral@transportesalentejolitoral.pt<br />
                            <b>Fax: 266 738 130</b>
                            <b>{strings.phone}:</b> 269 034 827<br /><br />
                            <p>{strings.contactWorkingDays}<br />
                            {strings.contactSaturdays}<br />
                            {strings.contactSundays}</p>
                        </div>
                        <Form onSubmit={this.sendMail} className="mb-3">
                            <div class="mt-3">
                                {strings.sendMessage}
                            </div>

                            <Form.Group className="mb-3" controlId="name">
                                <Form.Control className="contact-input" required placeholder={strings.name} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="email">
                                <Form.Control type="email" className="contact-input" required placeholder={strings.email} />
                                <Form.Text className="text-muted">
                                    {strings.emailWarning}
                                </Form.Text>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="subjectType">
                                <Form.Select className="contact-input" aria-label={strings.subject}>
                                    {
                                        subjectOptions.map((option, index) =>
                                            <option key={option} value={option}>{option}</option>
                                        )
                                    }

                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="subject">
                                <Form.Control className="contact-input" required placeholder={strings.subject} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="message">
                                <Form.Control as="textarea" rows={5} className="contact-input" required placeholder={strings.message} />
                            </Form.Group>

                            <Button className="contact-send-button" variant="primary" type="submit" disabled={!this.state.sending}>
                                {strings.send}
                            </Button>

                            <Form.Group>
                                <br />
                                {strings.contactsPrivacyDisclaimer}<a href="/privacypolicy">{strings.privacyPolicy}</a>.
                                <br />
                                <br />
                                <Form.Check
                                    label={strings.contactsPrivacyCheckbox}
                                    checked={this.state.sending}
                                    onChange={() => this.onCheckboxChange()}
                                />
                                <br />
                            </Form.Group>

                            {this.state.result !== undefined
                                ? <Alert className="mt-3" variant={this.state.result ? "success" : "danger"}>
                                    {this.state.result
                                        ? strings.emailSuccess
                                        : strings.emailError}
                                </Alert>
                                : null}
                        </Form>
                    </Col>
                </Row>
            </Container>
        );
    }
}
